import { NonExpressFormStep } from "../Sections";
import { Account } from "./Account";
import { DocumentsDetails } from "./Document";
import { Person, DeceasedDetails } from "./Person";

export interface NonExpressFormData {
  readonly notifier?: Person;
  readonly accounts?: ReadonlyArray<Account>;
  readonly deceased?: DeceasedDetails;
  readonly nok?: Person;
  readonly executor?: Person;
  readonly documents?: DocumentsDetails;
  readonly submittedSections: NonExpressFormStep;
  readonly kycPending: boolean;
  readonly submitted: boolean;
}

export enum YesNo {
  Yes = "YES",
  No = "NO",
}

// Helper functions and objects.
export const fullDetailsRequiredFields: ReadonlyArray<keyof Person> = [
  "firstName",
  "lastName",
  "address",
  "postcode",
  "contactNumber",
  "email",
  "title",
  "city",
];

export * from "./Person";
export * from "./ServiceProvider";
